import HeaderBase from './components/cells/HeaderBase';
import HeaderIcon from './components/cells/HeaderIcon';

export default function HeaderIconCell() {}

HeaderIconCell.prototype.init = function (params) {
    this.eGui = HeaderBase(HeaderIcon(params), params);
    return;
};

HeaderIconCell.prototype.getGui = function () {
    return this.eGui;
};
